import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=5d18d470&scoped=true&"
import script from "./Password.vue?vue&type=script&lang=js&"
export * from "./Password.vue?vue&type=script&lang=js&"
import style0 from "../assets/styleLogin.css?vue&type=style&index=0&id=5d18d470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18d470",
  null
  
)

export default component.exports